const PRODUCT_TYPE_ENUM = {
    HP: 0,
    PCP: 1,
}

module.exports = {
    PRODUCT_TYPE_ENUM
};